/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deletePrescription } from '../fn/prescriptions/delete-prescription';
import { DeletePrescription$Params } from '../fn/prescriptions/delete-prescription';
import { getPrescriptionList } from '../fn/prescriptions/get-prescription-list';
import { GetPrescriptionList$Params } from '../fn/prescriptions/get-prescription-list';
import { getTreatmentPrescriptions } from '../fn/prescriptions/get-treatment-prescriptions';
import { GetTreatmentPrescriptions$Params } from '../fn/prescriptions/get-treatment-prescriptions';
import { PaginatedDataPrescriptionRowDto } from '../models/paginated-data-prescription-row-dto';
import { TreatmentPrescription } from '../models/treatment-prescription';

@Injectable({ providedIn: 'root' })
export class PrescriptionsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPrescriptionList()` */
  static readonly GetPrescriptionListPath = '/api/prescriptions';

  /**
   * Returns prescriptions by given filters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPrescriptionList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPrescriptionList$Response(params: GetPrescriptionList$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDataPrescriptionRowDto>> {
    return getPrescriptionList(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns prescriptions by given filters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPrescriptionList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPrescriptionList(params: GetPrescriptionList$Params, context?: HttpContext): Observable<PaginatedDataPrescriptionRowDto> {
    return this.getPrescriptionList$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedDataPrescriptionRowDto>): PaginatedDataPrescriptionRowDto => r.body)
    );
  }

  /** Path part for operation `getTreatmentPrescriptions()` */
  static readonly GetTreatmentPrescriptionsPath = '/api/prescriptions/';

  /**
   * Returns prescriptions by given treatment id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTreatmentPrescriptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTreatmentPrescriptions$Response(params: GetTreatmentPrescriptions$Params, context?: HttpContext): Observable<StrictHttpResponse<TreatmentPrescription>> {
    return getTreatmentPrescriptions(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns prescriptions by given treatment id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTreatmentPrescriptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTreatmentPrescriptions(params: GetTreatmentPrescriptions$Params, context?: HttpContext): Observable<TreatmentPrescription> {
    return this.getTreatmentPrescriptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<TreatmentPrescription>): TreatmentPrescription => r.body)
    );
  }

  /** Path part for operation `deletePrescription()` */
  static readonly DeletePrescriptionPath = '/api/prescriptions/{prescriptionNumber}';

  /**
   * Deactivate the prescription with the treatment id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePrescription()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePrescription$Response(params: DeletePrescription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deletePrescription(this.http, this.rootUrl, params, context);
  }

  /**
   * Deactivate the prescription with the treatment id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePrescription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePrescription(params: DeletePrescription$Params, context?: HttpContext): Observable<void> {
    return this.deletePrescription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
